export const BOOK_COVERS = {
  book1: "https://customer-assets.emergentagent.com/job_1b7103cb-60b2-49d7-8677-886184523930/artifacts/xslf9n4k_generated_image_20260124_034300_1.png",
  book2: "https://customer-assets.emergentagent.com/job_1b7103cb-60b2-49d7-8677-886184523930/artifacts/icg19nct_generated_image_20260124_043201_1.png",
  book3: "https://customer-assets.emergentagent.com/job_3828a6dc-0502-44a7-ab45-71a567e1d959/artifacts/g39e487y_generated_image_20260126_083415_1.png",
  book4: "https://customer-assets.emergentagent.com/job_3828a6dc-0502-44a7-ab45-71a567e1d959/artifacts/z8ysokvd_generated_image_20260126_083437_1.png",
  book5: "https://customer-assets.emergentagent.com/job_3828a6dc-0502-44a7-ab45-71a567e1d959/artifacts/vboydr4o_generated_image_20260126_083553_1.png",
};

export const books = [
  {
    id: 1, title: "Money's Origin Story", subtitle: "From Bartering Goats to Digital Chaos",
    description: "Join 5 friends as they discover how Gary's goat started it all! The wild history of money from ancient trades to digital gold.",
    cover: BOOK_COVERS.book1, series: "Web3 Chaos Chronicles", bookNumber: 1, comingSoon: false,
    downloadUrl: "https://customer-assets.emergentagent.com/job_ecdea318-1bef-4472-bf06-96d374e1353d/artifacts/lsrd3kh6_Moneys%20origin%20story%20Book%201%20%281%29.pdf"
  },
  {
    id: 2, title: "Why Blockchains Exist", subtitle: "(AKA Humans Can't Behave)",
    description: "Our 5 friends learn why we needed an unbreakable chain of trust – because humans just can't behave!",
    cover: BOOK_COVERS.book2, series: "Web3 Chaos Chronicles", bookNumber: 2, comingSoon: false
  },
  {
    id: 3, title: "Tokens", subtitle: "Not Casino Chips, Not Monopoly Money",
    description: "The gang stops learning and starts BUILDING! They create their own \"QUEST COINS\" for the neighborhood.",
    cover: BOOK_COVERS.book3, series: "Web3 Chaos Chronicles", bookNumber: 3, comingSoon: false
  },
  {
    id: 4, title: "NFTs Without the Scams", subtitle: "Screenshots, or Headaches",
    description: "QUEST COINS is thriving, but who REALLY started it? The crew discovers NFTs aren't just pictures.",
    cover: BOOK_COVERS.book4, series: "Web3 Chaos Chronicles", bookNumber: 4, comingSoon: false
  },
  {
    id: 5, title: "Web3 Games", subtitle: "Digital Ownership & The Future Internet",
    description: "Time to turn QUEST COINS into a GAME! Can they build something that survives without them?",
    cover: BOOK_COVERS.book5, series: "Web3 Chaos Chronicles", bookNumber: 5, comingSoon: false
  }
];
